import { render, staticRenderFns } from "./SGPBoxHeaderInfoComponent.vue?vue&type=template&id=2f501de5&scoped=true"
import script from "./SGPBoxHeaderInfoComponent.vue?vue&type=script&lang=js"
export * from "./SGPBoxHeaderInfoComponent.vue?vue&type=script&lang=js"
import style0 from "./SGPBoxHeaderInfoComponent.vue?vue&type=style&index=0&id=2f501de5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f501de5",
  null
  
)

export default component.exports